/*
Sohel 11/04/2022 2699818958 Implement Run Batch Trigger Group Functionality
rajesh 11/25/2022 2699818958 implement trigger execution history and download.
Ashraf 01/05/2023 2699818958 handling error response
Akhila 02/27/2023 2699818958 implemented preview file functionality
Sohel 04/17/2023 2699823790 Added Corporate Value Based on Company
Sohel 04/17/2023 2699823790 Fixed Corporate Populate Issue
Akhila 06/21/2023 2699823790 conditionally disable save and finish button on submission
*/
import {createSlice} from '@reduxjs/toolkit';
import {PHASE, EVENT_ACCESS_METHOD} from '../../../constants/Lookup';
import {httpPost} from '../../../util/Rest';
import {httpGet} from './../../../util/Rest';
import {submissionEnd} from '../CommonActions/commonActions';
const initialState = {
  successMsg: null,
  errorMsg: null,
  isLoading: false,
  dropDownData: {},
  addTriggerGroupStatus: null,
  triggerGroupData: {},
  clientCodeDropdownData: [],
  eventTacticDropdownData: [],
  runReportStatus: null,
  allGroupCode: [],
  triggerExecutionData: [],
  downloadStatus: null,
  groupCode: '',
  batchTriggerId: 0,
  isBatchTriggersDraft: '',
  lastStep: 0,
  configurationUrl: '',
  dockey: '',
  siteNameData: [],
  clientNumberData: [],
  corporateNameData: [],
};

const addTriggerGroup = createSlice({
  name: 'addTriggerGroup',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    postTriggerGroupData: (state, action) => {
      state.addTriggerGroupStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.groupCode = action.payload?.response?.groupCode;
      state.batchTriggerId = action?.payload?.response?.triggerGroupId;
    },
    getTriggerGroupData: (state, action) => {
      state.triggerGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.addTriggerGroupStatus = action.payload.status;
      state.successMsg = action.payload.response;
      state.batchTriggerId = action?.payload?.triggerGroupId;
    },
    postRunReportData: (state, action) => {
      state.runReportStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    getclientCodeData: (state, action) => {
      state.clientCodeDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getEventTacticData: (state, action) => {
      state.eventTacticDropdownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.addTriggerGroupStatus = null;
    },
    getAllGroupCode: (state, action) => {
      state.allGroupCode = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetData: (state) => {
      state.batchTriggerId = 0;
      state.triggerGroupData = {};
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
      state.runReportStatus = null;
    },
    setBatchTriggerCode: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setBatchTriggersDraft: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    setBatchTriggersLastStep: (state, action) => {
      state[action.payload.property] = action.payload.value;
    },
    resetRunReportData: (state) => {
      state.errorMsg = null;
      state.successMsg = null;
      state.runReportStatus = null;
      state.isLoading = false;
    },
    getTriggerExecutionData: (state, action) => {
      state.triggerExecutionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getSiteNameData: (state, action) => {
      state.siteNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getCorporateNameData: (state, action) => {
      state.corporateNameData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getClientNumberData: (state, action) => {
      state.clientNumberData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    resetTriggerData: (state) => {
      state.triggerExecutionData = [];
      state.isLoading = false;
    },
    postDownloadData: (state, action) => {
      state.isLoading = false;
    },
    resetGroupCodeData: (state, action) => {
      (state.groupCode = ''), (state.isBatchTriggersDraft = '');
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state, action) => {
      state.configurationUrl = '';
    },
    resetDockey: (state, action) => {
      state.dockey = '';
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
    resetSiteNameData: (state) => {
      state.siteNameData = [];
    },
    resetClientNumberData: (state) => {
      state.clientNumberData = [];
    },
    resetCorporateNameData: (state) => {
      state.corporateNameData = [];
    },
  },
});
export default addTriggerGroup.reducer;
export const {
  fetchStart,
  fetchError,
  fetchDropDownData,
  resetMsg,
  postTriggerGroupData,
  getTriggerGroupData,
  getclientCodeData,
  getEventTacticData,
  resetData,
  getAllGroupCode,
  postRunReportData,
  resetRunReportData,
  getTriggerExecutionData,
  fetchSuccess,
  resetTriggerData,
  postDownloadData,
  resetGroupCodeData,
  setBatchTriggerCode,
  setBatchTriggersDraft,
  setBatchTriggersLastStep,
  setConfigUrl,
  resetConfigUrl,
  setDockey,
  resetDockey,
  getSiteNameData,
  getClientNumberData,
  getCorporateNameData,
  resetSiteNameData,
  resetClientNumberData,
  resetCorporateNameData,
} = addTriggerGroup.actions;

export const getDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [EVENT_ACCESS_METHOD, PHASE],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postTriggerGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/save/triggergroup`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postTriggerGroupData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postRunReport = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`event/execute/batch/triggergroup`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postRunReportData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchTriggerGroup = (triggerGroupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/find/triggergroup/${triggerGroupId}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(getTriggerGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const getClientCodeDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/all/clientcodeandnames`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getclientCodeData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchAllGroupCode = () => {
  return (dispatch) => {
    httpGet(`event/getAll/groupcode`)
      .then((data) => {
        if (data?.status && data.status === 200) {
          dispatch(getAllGroupCode(data?.response));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchSiteNameData = (corporateId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`organization/find/sitedetails/${corporateId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getSiteNameData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchCorporateNameData = (companyId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`company/findall/companyidandname/${companyId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCorporateNameData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchClientNumberData = (siteId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`business/get/client/${siteId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getClientNumberData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getEventTacticDropDownData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/getAll/event`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getEventTacticData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const triggerExecutions = (triggerGroupId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`event/get/executionhistory/${triggerGroupId}`)
      .then((data) => {
        if (data && data?.status === 200) {
          dispatch(getTriggerExecutionData(data.response));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postDownloadTrigger = (payload, postRuleGroupData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`report/execution/generateurlprint/accounttacticexecution`, payload)
      .then((data) => {
        if (data && data?.status === 200) {
          // dispatch(postDownloadData())
          // download(data.data);
          dispatch(setConfigUrl(data?.data || ''));
          dispatch(setDockey(payload?.dockey));
        } else if (data && data?.data?.status === 500) {
          dispatch(fetchError(data?.data?.error));
        } else {
          dispatch(fetchError(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};

export const resetTriggerGroupData = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};
export const resetTriggersData = () => {
  return (dispatch) => {
    dispatch(resetTriggerData());
  };
};

export const resetGroupCode = () => {
  return (dispatch) => {
    dispatch(resetGroupCodeData());
  };
};

export const resetRunReport = () => {
  return (dispatch) => {
    dispatch(resetRunReportData());
  };
};
export const resetSiteName = () => {
  return (dispatch) => {
    dispatch(resetSiteNameData());
  };
};
export const resetClientNumber = () => {
  return (dispatch) => {
    dispatch(resetClientNumberData());
  };
};
export const resetCorporateName = () => {
  return (dispatch) => {
    dispatch(resetCorporateNameData());
  };
};
